<div class="ActivitiesAdBanner">
    <div class="ActivitiesAdBanner__content">
      <div class="ActivitiesAdBanner__header">
        <div class="ActivitiesAdBanner__icon">
          <app-ds-icon
            [icon]="iconCivitatis"
            [color]="iconFillColor.Light"
            [size]="buttonIconSize">
          </app-ds-icon>
        </div>
        <app-ds-typography
          [text]="'SEARCH_MODULE.BANNER_TOUR_AND_ACTIVITIES.AD' | transloco"
          [size]="fontSize.XXXS"
          [fontFamily]="fontFamily.Regular"
          [color]="fontColor.Primary">
        </app-ds-typography>
      </div>
      <p>
        <app-ds-typography
            [text]="'SEARCH_MODULE.BANNER_TOUR_AND_ACTIVITIES.DESCRIPTION' | transloco"
            [size]="fontSize.XXS"
            [fontFamily]="fontFamily.Regular"
            [color]="fontColor.Secondary">
          </app-ds-typography>
          <app-ds-typography
          [text]="'SEARCH_MODULE.BANNER_TOUR_AND_ACTIVITIES.DESCRIPTION_COMPLEMENT' | transloco"
          [size]="fontSize.XXS"
          [fontFamily]="fontFamily.SemiBold"
          [color]="fontColor.Secondary">
        </app-ds-typography>
      </p>
    </div>
  </div>
  